import React from 'react';

const Notes = (props) => {
    const { note, doctorName } = props.appointment;

    return (
        <div className="container d-flex flex-column elements-spacing">
            <div id="notes">
                <p className="notes_content" dangerouslySetInnerHTML={{ __html: note }} />
                <div className="notes_greeting d-flex justify-content-end">
                    תודה,
                    <br />
                    {doctorName}
                </div>
            </div>
        </div>
    );
}

export default Notes;